const values = [
  "responsibility over victimhood",
  "restraint over outrage",
  "long-term thinking over shortcuts",
];

export default function ActivismScene() {
  return (
    <section
      className="home-band home-band--quiet px-5 sm:px-8"
      style={{
        background: "hsl(var(--ink))",
        borderTop: "1px solid hsl(var(--marigold) / 0.18)",
        borderBottom: "1px solid hsl(var(--marigold) / 0.18)",
      }}
    >
      <div className="max-w-3xl mx-auto text-center w-full">
        <div className="scroll-reveal" style={{ marginBottom: "clamp(1.5rem, 3vh, 2.25rem)" }}>
          <span
            aria-hidden
            className="block mx-auto mb-5"
            style={{ width: 60, height: 1, background: "hsl(var(--marigold) / 0.7)" }}
          />
          <p className="section-eyebrow mb-4">Our values</p>
          <h2 className="section-heading">
            This is the code we run on.
          </h2>
        </div>

        <div
          className="flex flex-col items-center"
          style={{ gap: "clamp(1rem, 2.5vh, 1.5rem)", marginBottom: "clamp(1.5rem, 3vh, 2.25rem)" }}
        >
          {values.map((value) => (
            <p
              key={value}
              className="scroll-reveal font-display italic"
              style={{
                fontSize: "clamp(1.25rem, 2.4vw, 1.7rem)",
                color: "hsl(var(--manuscript))",
                lineHeight: 1.3,
              }}
            >
              {value}
            </p>
          ))}
        </div>

        <div
          className="scroll-reveal border-t border-border/30 max-w-xs mx-auto"
          style={{ paddingTop: "clamp(1rem, 2vh, 1.5rem)" }}
        >
          <p className="text-muted-foreground italic" style={{ fontSize: "clamp(0.7rem, 1vw, 0.875rem)" }}>
            This is not belief.
          </p>
          <p className="text-accent font-semibold mt-1" style={{ fontSize: "clamp(0.85rem, 1.2vw, 1rem)" }}>
            This is practice.
          </p>
        </div>
      </div>
    </section>
  );
}
